import { Moment } from 'moment'

import { Period } from 'services/booking/periods/models'

export enum ActionType {
  create = 'create',
  delete = 'delete',
  update = 'update'
}

export interface PeriodTime {
  endDate?: Date | Moment | string
  id?: number
  period?: Period
  startDate?: Date | Moment | string
}
